import { render, staticRenderFns } from "./ProvinceCity.vue?vue&type=template&id=25e636c4&scoped=true&"
import script from "./ProvinceCity.vue?vue&type=script&lang=js&"
export * from "./ProvinceCity.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceCity.vue?vue&type=style&index=0&id=25e636c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e636c4",
  null
  
)

export default component.exports